import type { FaireProductEntity } from "../../entity_types/product";

export const p_c0hafp9vmv: FaireProductEntity = {
  token: "p_c0hafp9vmv",
  type: "product",
  name: "14k Gold Filled Crescent Moon Charm/Pendant Necklace",
  brandToken: "b_88ixvyij",
  brandName: "Admiral Row Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/f42adea77ebc8ffe8f4af426bece782aeab874213b1decb6f0dd765b26aa0c0e.jpeg",
  galleryImageUrls: [],
  priceDollars: 23.5,
  description:
    "This gold tiny crescent moon necklace has the perfect boho vibe. Can be worn on its own or perfect for layering.\nColor: Gold\nMaterial: Chain: 14kt Gold Filled; Pendant: Gold Plated Brass.\nSize: Chain Length: 16″ or 18″; Pendant:18x21mm\nNickel Free",
  tags: [],
  msrpDollars: 53.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:40.761Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
